import GroupBranchEditDialog from "./groupBranchEditDialog.container";

export default GroupBranchEditDialog;
